// ------
// Styles
// ------

import "normalize.css/normalize.css";
import "./styles/index.scss";

// ---------
// SVG icons
// ---------

import "./icons";

// -------
// Vendors
// -------
import axios from 'axios';
import Sticky from 'sticky-js';
import tippy from 'tippy.js';
// import Swiper from 'swiper/bundle';

// -------
// Scripts
// -------
import global from './scripts/global.js';
import readMore from './scripts/read-more.js';
import toggler from './scripts/toggler.js';
import loadMore from './scripts/load-more.js';
import rating from './scripts/rating.js';
import infiniteLoader from './scripts/infinite-loader.js';
import videoPlaylist from './scripts/video-playlist.js';
import modals from './scripts/modals.js';
import modalsVideo from './scripts/modals-video.js';
import tabs from './scripts/tabs.js';
import globalCookies from './scripts/global-cookies.js';
import selectEdition from "./scripts/select-edition.js";
import reviewModal from "./scripts/review-modal.js";

// ----------
// Components
// ----------
import carousel from './components/Carousel/Carousel.js';
import indexes from './components/Indexes/Indexes.js';
import faq from "./components/faq/faq.js";
// import crossSell from "./components/crosssell/crosssell.js";
import filterTags from "./components/filtertags/filtertags.js";
import dropdownFilter from "./components/dropdownfilter/dropdownfilter.js";
// import heroSlider from "./components/heroslider/heroslider.js";

// Run init function for all files when document is ready
document.addEventListener("DOMContentLoaded", () => {
  setTimeout(() => { init() }, 1000)
});

function init() {

  /*
  axios.get('/rest/session/token')
    .then((data) => {
      console.log('data')
    })
  */

  tippy('[data-tippy-content]') // initialize tippy
  global.init()
  setTimeout(() => { modals.init() }, 1000) // todo: better implementation when domready
  readMore.init()
  toggler.init()
  loadMore.init()
  indexes.init()
  infiniteLoader.init()
  tabs.init();
  videoPlaylist.init()
  rating.init()
  carousel.init()
  faq.init()
  selectEdition.init()
  // crossSell.init()
  filterTags.init()
  dropdownFilter.init()
  // heroSlider.init()
  globalCookies.init()
  modalsVideo.init()
}
